import { cn } from '@/lib/utils';

const P = ({
    variant = 'default',
    color = 'black',
    className,
    isHtml = false,
    ...props
}: React.HTMLAttributes<HTMLParagraphElement> & {
    variant?: 'default' | 'link' | 'large' | 'light' | 'credit';
    color?: 'black' | 'inherit';
    isHtml?: boolean;
}) => {
    const variantClasses = {
        default:
            'lg:text-[18px] text-[16px] 2xl:text-[18px] pressura leading-[120%] inline-block',
        link: 'lg:text-[18px] text-[16px] 2xl:text-[18px] pressura leading-[120%] inline-block underline hover:no-underline',
        large: 'lg:text-[18px] text-[18px] 2xl:text-[20px] pressura leading-[120%] inline-block',
        light: 'lg:text-[18px] font-light text-[16px] 2xl:text-[18px] pressura-light leading-[120%] inline-block',
        credit: 'lg:text-[18px] text-[16px] 2xl:text-[20px] pressura leading-[120%] inline-block',
    };

    const colorClasses = {
        black: 'text-black',
        inherit: 'text-inherit',
    };

    return (
        <div
            className={cn(
                variantClasses[variant],
                colorClasses[color],
                className,
            )}
            {...(isHtml
                ? {
                      dangerouslySetInnerHTML: {
                          __html: props.children as string,
                      },
                  }
                : {})}
            {...(!isHtml ? props : {})}
        />
    );
};

P.displayName = 'P';

export default P;
